/* eslint-disable */
import type { LocalizedString } from "../cash/localization/localization.pb";

export interface LoanRepaymentSelectionData {
  title?: LocalizedString;
  repayment_choices?: LoanRepaymentSelectionDataChoice[];
  dismiss_button_text?: LocalizedString;
}

/** Tintable via the tile's tint_color property. */
export interface LoanRepaymentSelectionDataChoice {
  primary_text?: LocalizedString;
  secondary_text?: LocalizedString;
  icon?: LoanRepaymentSelectionDataChoiceIcon;
  /**
   * A pre-configred dl/flow... url with seed data already populated
   * for the amount to pay and any other necessary information to start
   * the flow. In the case of "Custom Amount" the Client route should
   * be `dl/view/borrow/repay-custom-amount`.
   */
  action_url?:
    | string
    | undefined;
  /**
   * In some repayment cases (where a customer has multiple loans), the
   * customer is asked to select a loan followed by an amount or a transaction.
   * This allows us to have multiple half sheet presentations.
   */
  additional_selection?: LoanRepaymentSelectionData | undefined;
}

export enum LoanRepaymentSelectionDataChoiceIcon {
  BORROW = "BORROW",
  QUESTION = "QUESTION",
}
